import { isPresetColor, colors, isPaletteKey, hexToRgba, palette } from '@flex-design-system/fx-colors';
import { vars } from '@flex-design-system/ve-presets';
import { getColor } from '../../../utils/colors.mjs';

const WEAK_VARIANT_BACKGROUND_ALPHA_VALUE = 0.12;
function getTagColor(params) {
  const { color, variant } = params;
  const themeColor = isPresetColor(color) ? colors[color] : color;
  switch (variant) {
    case "outline": {
      return {
        color: themeColor,
        background: vars.colors.white
      };
    }
    case "solid": {
      return {
        color: vars.colors.white,
        background: getColor(color)
      };
    }
    case "weak": {
      if (isPaletteKey(color) && color !== "gradient") {
        const paletteColor = palette[color];
        return {
          color: "darker" in paletteColor ? paletteColor.darker : paletteColor.default,
          background: hexToRgba(
            paletteColor.default,
            WEAK_VARIANT_BACKGROUND_ALPHA_VALUE
          )
        };
      }
      return {
        color: vars.colors.grayDarker,
        background: hexToRgba(
          isPresetColor(color) ? colors[color] : color,
          WEAK_VARIANT_BACKGROUND_ALPHA_VALUE
        )
      };
    }
    default:
      throw new Error(
        `[Tag] '${variant}'\uB294 \uC815\uC758\uB418\uC9C0 \uC54A\uC740 Tag variant \uC720\uD615\uC774\uC5D0\uC694.`
      );
  }
}

export { getTagColor };
//# sourceMappingURL=color.mjs.map
